/**
 * @generated SignedSource<<c6d810e71e7d9dcc1d662dd4d17e0398>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleFilterOrganizer = "ANYONE" | "SELF";
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
export type AutoRecordRuleType = "RECORD" | "RESTRICT";
export type FilterAttendeeType = "EXTERNAL_ONLY" | "INTERNAL_AND_EXTERNAL" | "INTERNAL_ONLY";
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemRule$data = {
  readonly filterAttendeeType: FilterAttendeeType;
  readonly filterKeywordsContains: ReadonlyArray<string | null> | null;
  readonly filterKeywordsRestrict: ReadonlyArray<string | null> | null;
  readonly filterMaximumAttendees: number | null;
  readonly filterMinimumAttendees: number | null;
  readonly filterOrganizer: AutoRecordRuleFilterOrganizer;
  readonly id: string;
  readonly ruleLevel: AutoRecordRuleLevel;
  readonly ruleType: AutoRecordRuleType;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemAppliesTo" | "AutoRecordRulesListItemDuplicateAutoRecordRule" | "AutoRecordRulesListItemRuleDeletionConfirmModal" | "CreateAndEditModalRule">;
  readonly " $fragmentType": "AutoRecordRulesListItemRule";
};
export type AutoRecordRulesListItemRule$key = {
  readonly " $data"?: AutoRecordRulesListItemRule$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemRule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemRule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ruleLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterAttendeeType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterMinimumAttendees",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterMaximumAttendees",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterKeywordsContains",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterKeywordsRestrict",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterOrganizer",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoRecordRulesListItemAppliesTo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoRecordRulesListItemRuleDeletionConfirmModal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AutoRecordRulesListItemDuplicateAutoRecordRule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateAndEditModalRule"
    }
  ],
  "type": "AutoRecordRule",
  "abstractKey": null
};

(node as any).hash = "1e0ff791d9e2b4050b180c7eaa4f5e77";

export default node;
